import React, { PropsWithChildren, useEffect } from 'react';
import LoadingSpinnerWithoutOverlay, { LoadingSpinnerProps } from './LoadingSpinnerWithoutOverlay';
import { ApolloError } from '@apollo/client';

export type WithQueryProps = PropsWithChildren<{
  loading?: boolean;
  error?: ApolloError | Error | string | boolean | null;
  errorRedirect?: string;
  ErrorComponent?: React.FC<any>;
  spinnerProps?: LoadingSpinnerProps;
}>;

const WithQuery = ({
  loading,
  error,
  children,
  ErrorComponent,
  spinnerProps
}: WithQueryProps): React.ReactElement => {
  useEffect(() => {
    if (error) console.error(error);
    if (error && !ErrorComponent) {
      // do nothing
      //history.push(errorRedirect, { replace: true });
    }
    // eslint-disable-next-line
  }, [error]);

  if (loading) {
    return <LoadingSpinnerWithoutOverlay {...spinnerProps} />;
  }
  return error ? ErrorComponent ? <ErrorComponent /> : <></> : <>{children}</>;
};

export default WithQuery;
